var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.tableData.length ? _c('b-table', {
    ref: "rosterTable",
    class: _vm.$style.rosterTable,
    attrs: {
      "fields": _vm.tableFields,
      "items": _vm.tableData,
      "tbody-tr-class": _vm.getTrClass,
      "borderless": "",
      "no-border-collapse": "",
      "responsive": "",
      "sort-icon-left": ""
    },
    on: {
      "row-clicked": _vm.goToReferral
    },
    scopedSlots: _vm._u([{
      key: "cell(state)",
      fn: function fn(data) {
        return [_vm.isMobile ? [data.item.referralCategory === 'received' || data.item.referralCategory === 'office_received' ? _c('div', {
          class: _vm.$style.mobileReferralItem
        }, [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('p', [_vm._v(" " + _vm._s(data.item.state) + " ")]), _c('p', [_vm._v(" " + _vm._s(data.item.officeReceivedStatus || data.item.receivedStatus) + " ")])]), _c('p', [_vm._v("Loan Type: " + _vm._s(data.item.loanType || 'N/A'))]), _c('p', [_vm._v("Loan Amount: " + _vm._s(data.item.loanAmount || 'N/A'))]), _c('p', [_vm._v("Date Received: " + _vm._s(_vm.moment.unix(data.item.receivedAt).format('M/D/yyyy')))]), _c('p', [_vm._v("Sender: " + _vm._s(data.item.receivedStatus === 'Completed' ? data.item.sender : 'N/A'))]), _c('p', [_vm._v("Assigned: " + _vm._s(data.item.assigned || 'N/A'))]), _c('div', {
          staticClass: "d-flex align-items-center justify-content-end"
        }, [data.item.receivedStatus === 'Completed' ? _c('a', {
          class: _vm.$style.contactIcon,
          attrs: {
            "href": "tel:".concat(data.item.createdBy.phone)
          }
        }, [_c('MottoIcon', {
          staticClass: "ml-3 mr-2",
          attrs: {
            "name": "Phone",
            "icon-color": "orange"
          }
        })], 1) : _vm._e(), data.item.receivedStatus === 'Completed' ? _c('a', {
          class: _vm.$style.contactIcon,
          attrs: {
            "href": "mailto:".concat(data.item.createdBy.email, "?subject=Completed ").concat(data.item.state || '', " ").concat(data.item.loanType || '', " deal level referral")
          }
        }, [_c('MottoIcon', {
          staticClass: "ml-1 mr-3",
          attrs: {
            "name": "Envelope",
            "icon-color": "orange"
          }
        })], 1) : _vm._e()])]) : _c('div', {
          class: _vm.$style.mobileReferralItem
        }, [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('p', [_vm._v(" " + _vm._s(data.item.state) + " ")]), _c('p', [_vm._v(" " + _vm._s(data.item.status) + " ")])]), _c('p', [_vm._v("Loan Type: " + _vm._s(data.item.loanType || 'N/A'))]), _c('p', [_vm._v("Loan Amount: " + _vm._s(data.item.loanAmount || 'N/A'))]), _c('p', [_vm._v("Recipients: " + _vm._s(data.item.recipients))]), _c('p', [_vm._v("Date Sent: " + _vm._s(_vm.moment.unix(data.item.dateSent).format('M/D/yyyy')))]), _c('div', {
          staticClass: "d-flex align-items-center justify-content-end"
        }, [data.item.status === 'Completed' && _vm.getAcceptedUserForCompletedReferral(data.item).phone ? _c('a', {
          class: _vm.$style.contactIcon,
          attrs: {
            "href": "tel:".concat(_vm.getAcceptedUserForCompletedReferral(data.item).phone || '')
          }
        }, [_c('MottoIcon', {
          staticClass: "ml-3 mr-2",
          attrs: {
            "name": "Phone",
            "icon-color": "orange"
          }
        })], 1) : _vm._e(), data.item.status === 'Completed' && _vm.getAcceptedUserForCompletedReferral(data.item).email ? _c('a', {
          class: _vm.$style.contactIcon,
          attrs: {
            "href": "mailto:".concat(_vm.getAcceptedUserForCompletedReferral(data.item).email, "?subject=Completed ").concat(data.item.state || '', " ").concat(data.item.loanType || '', " deal level referral")
          }
        }, [_c('MottoIcon', {
          staticClass: "ml-1 mr-3",
          attrs: {
            "name": "Envelope",
            "icon-color": "orange"
          }
        })], 1) : _vm._e()])])] : [_vm._v(" " + _vm._s(data.value) + " ")]];
      }
    }, {
      key: "cell(sender)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.receivedStatus === 'Completed' ? data.value : 'N/A') + " ")];
      }
    }, {
      key: "cell(assigned)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.value || 'N/A') + " ")];
      }
    }, {
      key: "cell(recipients)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.value || 'N/A') + " ")];
      }
    }, {
      key: "cell(loanType)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.value || 'N/A') + " ")];
      }
    }, {
      key: "cell(loanAmount)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.value || 'N/A') + " ")];
      }
    }, {
      key: "cell(dateSent)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.moment.unix(data.value).format('M/D/yyyy')) + " ")];
      }
    }, {
      key: "cell(dateReceived)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.moment.unix(data.value).format('M/D/yyyy')) + " ")];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex position-relative"
        }, [_c('span', {
          staticClass: "d-flex align-items-center mr-4"
        }, [_vm._v(" " + _vm._s(data.value) + " "), data.value === 'Completed' && _vm.getAcceptedUserForCompletedReferral(data.item).phone ? _c('a', {
          class: _vm.$style.contactIcon
        }, [_c('MottoIcon', {
          staticClass: "ml-3 mr-2",
          attrs: {
            "id": "phone".concat(data.item.id),
            "name": "Phone",
            "icon-color": "orange"
          }
        }), _c('b-tooltip', {
          attrs: {
            "triggers": _vm.isMobile ? '' : 'click blur',
            "target": "phone".concat(data.item.id),
            "placement": "top",
            "custom-class": "tooltipBlue ".concat(_vm.$style.copyToClipboardTooltip)
          }
        }, [_vm._v(" " + _vm._s(_vm.getAcceptedUserForCompletedReferral(data.item).phone) + " "), _c('CopyToClipboardButton', {
          attrs: {
            "text-to-copy": _vm.getAcceptedUserForCompletedReferral(data.item).phone,
            "theme": "square",
            "icon": "Copy"
          }
        })], 1)], 1) : _vm._e(), data.value === 'Completed' && _vm.getAcceptedUserForCompletedReferral(data.item).email ? _c('a', {
          class: _vm.$style.contactIcon,
          attrs: {
            "href": "mailto:".concat(_vm.getAcceptedUserForCompletedReferral(data.item).email, "?subject=Completed ").concat(data.item.state || '', " ").concat(data.item.loanType || '', " deal level referral")
          }
        }, [_c('MottoIcon', {
          staticClass: "ml-1 mr-3",
          attrs: {
            "id": "envelope".concat(data.item.id),
            "name": "Envelope",
            "icon-color": "orange"
          }
        }), _c('b-tooltip', {
          attrs: {
            "target": "envelope".concat(data.item.id),
            "placement": "top",
            "custom-class": "tooltipBlue"
          }
        }, [_vm._v(" Email referree ")])], 1) : _vm._e()]), _vm.getStatusTooltipText(data.value, data.item) ? _c('Tooltip', {
          class: _vm.$style.tableTooltip,
          attrs: {
            "target": "".concat(data.item.id),
            "placement": "left",
            "theme": "blue",
            "custom-class": _vm.$style.tableTooltipInner
          }
        }, [_vm._v(" " + _vm._s(_vm.getStatusTooltipText(data.value, data.item)) + " ")]) : _vm._e()], 1)];
      }
    }, {
      key: "cell(receivedStatus)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex position-relative"
        }, [_c('span', {
          staticClass: "d-flex align-items-center mr-4"
        }, [_vm._v(" " + _vm._s(data.item.officeReceivedStatus || data.value) + " "), data.value === 'Completed' ? _c('a', {
          class: _vm.$style.contactIcon
        }, [_c('MottoIcon', {
          staticClass: "ml-3 mr-2",
          attrs: {
            "id": "phone".concat(data.item.id),
            "name": "Phone",
            "icon-color": "orange"
          }
        }), _c('b-tooltip', {
          attrs: {
            "triggers": _vm.isMobile ? '' : 'click blur',
            "target": "phone".concat(data.item.id),
            "placement": "top",
            "custom-class": "tooltipBlue ".concat(_vm.$style.copyToClipboardTooltip)
          }
        }, [_vm._v(" " + _vm._s(data.item.createdBy.phone) + " "), _c('CopyToClipboardButton', {
          attrs: {
            "text-to-copy": data.item.createdBy.phone,
            "theme": "square",
            "icon": "Copy"
          }
        })], 1)], 1) : _vm._e(), data.value === 'Completed' ? _c('a', {
          class: _vm.$style.contactIcon,
          attrs: {
            "href": "mailto:".concat(data.item.createdBy.email, "?subject=Completed ").concat(data.item.state || '', " ").concat(data.item.loanType || '', " deal level referral")
          }
        }, [_c('MottoIcon', {
          staticClass: "ml-1 mr-3",
          attrs: {
            "id": "envelope".concat(data.item.id),
            "name": "Envelope",
            "icon-color": "orange"
          }
        }), _c('b-tooltip', {
          attrs: {
            "target": "envelope".concat(data.item.id),
            "placement": "top",
            "custom-class": "tooltipBlue"
          }
        }, [_vm._v(" Email referrer ")])], 1) : _vm._e()]), _vm.getStatusTooltipText(data.item.officeReceivedStatus || data.value, data.item) ? _c('Tooltip', {
          class: _vm.$style.tableTooltip,
          attrs: {
            "target": "".concat(data.item.id),
            "placement": "left",
            "theme": "blue",
            "custom-class": _vm.$style.tableTooltipInner
          }
        }, [_vm._v(" " + _vm._s(_vm.getStatusTooltipText(data.item.officeReceivedStatus || data.value, data.item)) + " ")]) : _vm._e()], 1)];
      }
    }], null, false, 1075715646)
  }) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }